// extracted by mini-css-extract-plugin
export default {"card":"Card_card__XfvNE","card-dark":"Card_card-dark__bvDES"};